import { render, staticRenderFns } from "./loader.component.html?vue&type=template&id=d630a020&scoped=true&"
import script from "./loader.component.ts?vue&type=script&lang=ts&"
export * from "./loader.component.ts?vue&type=script&lang=ts&"
import style0 from "./loader.component.scss?vue&type=style&index=0&id=d630a020&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d630a020",
  null
  
)

export default component.exports